// Sends the telemetry beacon to /ingest and returns the challenge token.
// Uses fetch with keepalive so the request survives navigation; falls back to
// sendBeacon when the page is unloading.
import { SignalSummary } from "./collectors";

export interface BeaconResponse {
  token: string;
  session_id: string;
}

const SDK_VERSION = "0.1.0";

export async function sendBeacon(
  endpoint: string,
  siteKey: string,
  sessionId: string,
  action: string,
  signals: SignalSummary,
): Promise<BeaconResponse | null> {
  const body = JSON.stringify({
    site_key: siteKey,
    session_id: sessionId,
    action,
    signals,
    sdk_version: SDK_VERSION,
  });
  try {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
      credentials: "omit",
    });
    if (!res.ok) return null;
    return (await res.json()) as BeaconResponse;
  } catch {
    return null;
  }
}
